module.exports = __webpack_public_path__ + "static/media/USDT(TRC20).e6ad0a93.jpeg";